module.exports = __webpack_public_path__ + "static/media/1.cc71f096.jpeg";